import React, { ReactNode } from 'react';
import { PerformanceLabsIndiaProvider } from './PerformanceLabsIndiaContext';

interface IndiaLayoutProps {
  children: ReactNode;
}

const IndiaLayout: React.FC<IndiaLayoutProps> = ({ children }) => {
  return (
    <PerformanceLabsIndiaProvider>{children}</PerformanceLabsIndiaProvider>
  );
};

export default IndiaLayout;
